import React, { useEffect, useMemo, useState } from 'react';
import Header from '../../components/Header/Header';
// import '../../Pages/styles.css'
import './VideoTutorials.css';
import { VideoTutorialsComponent } from './VideoTutorialsComponent';
import Footer from '../../components/Footer/Footer';
import { Globals } from '../../global/Globals';
import { fetchAPI } from '../../services/api';
import NoResultsComponent from '../../components/NoResults/NoResult';
import Loader from '../../components/Loader/Loader';

const VideoTutorials = () => {
    const [data, setData] = useState([]);
    const [contentDataStatus, setContentDataStatus] = useState(null)
    useEffect(()=>{
          const getData = async () => {
              try {
                // Uncomment these lines if you need to fetch notifications from an API.
                const result = await fetchAPI(Globals.ENDPOINT.VIDEOTUTORIALS);
                setContentDataStatus(result.status);
                setData(result);
              } catch (error) {
                setContentDataStatus("error ");
                console.error('Error in App component:', error);
              }
            };
        getData();
    },[])
    return (
        <div className="Background-Page">
             <div className='videoTutorials-Page'>
            <Header onlyPicture="true" />
            <div className="Main">
            {data?.content?.length?
            
            <div className='videoTutorialWrapper'>
            <div className='videoTutorials-Header'>
                {Globals.VIDEOTUTORIALS}
            </div>
            <div className="Main">
            
            <div className='videoTutorials-comp'>
            {data?.content?.length>0&&<VideoTutorialsComponent data={data}/>}
            </div>
            </div>
            
            </div>
            :contentDataStatus && contentDataStatus?.length > 0 ? <>
            <><NoResultsComponent data={{message:Globals.NO_DATA,img:Globals.NO_DATA_FOUND_IMG}}/></>
            </>:<div className="NoResultsComponent" style={{height:"100vh"}}>
          <Loader height={50} width={50} component={"Notifications"}/>
          </div>}
            
            
        </div> 
        </div>
        <Footer />
        </div>
       
    );
};

export default VideoTutorials;
